import { post, get } from '../axios'

// list
export function abtest_list_post(map, option) {
  return post(`${process.env.VUE_APP_ABTEST}/abtest/list`, map, option).then(
    response => response
  )
}

export function abtest_select_post(map, option) {
  return post(
    `${process.env.VUE_APP_LANG}/mdm/country/region/v2/list-post`,
    map,
    option
  ).then(response => response)
}

// modifyAbStatus
export function abtest_modifystatus_post(map, option) {
  return post(
    `${process.env.VUE_APP_ABTEST}/abtest/modifystatus`,
    map,
    option
  ).then(response => response)
}

// queryAbtest
export function abtest_query_get(map, option) {
  return get(`${process.env.VUE_APP_ABTEST}/abtest/query`, map, option).then(
    response => response
  )
}

// save
export function abtest_save_post(map, option) {
  return post(`${process.env.VUE_APP_ABTEST}/abtest/save`, map, option).then(
    response => response
  )
}
